<template>
  <div>
    <v-dialog v-model="dialog" width="800" :persistent="true">
      <v-card>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>{{ 'app.product_category.remove_category' | trans }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark small @click="closeModal()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md no-padding>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <p>{{ 'app.product_category.remove_information' | trans }}</p>
                  <v-select
                      :items="availableCategories"
                      :label="trans('app.product_category.title')"
                      item-value="id"
                      item-text="name"
                      v-model="selectedCategory"
                      :clearable="true"
                      :rules="rules.category"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">
            {{ 'app.close' | trans }}
          </v-btn>
          <v-btn color="primary" @click="rewriteSubcategoriesAndProductCategoriesAndRemove" :disabled="!valid" :loading="loading">
            {{ 'app.delete_and_save' | trans }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <li>
      <v-chip color="primary" text-color="white">{{ productCategory.name }}</v-chip>
      <icon-button
          icon="edit"
          color="success"
          :tooltip="{top: true, bottom: false, attach: false}"
          :iconOptions="{small: true}"
          @click="edit()"
      >
        {{ 'app.edit' | trans }}
      </icon-button>
      <icon-button
          icon="animation"
          color="blue"
          :tooltip="{top: true, bottom: false, attach: false}"
          :iconOptions="{small: true}"
          @click="createChild()"
      >
        {{ 'app.product_category.add_subcategory' | trans }}
      </icon-button>
      <icon-button
          icon="delete"
          color="red"
          :tooltip="{top: true, bottom: false, attach: false}"
          :iconOptions="{small: true}"
          @click="remove()"
      >
        {{ 'app.delete' | trans }}
      </icon-button>
    </li>
    <ul>
      <li v-if="productCategory.subcategories.length > 0" v-for="subcategory in productCategory.subcategories" :key="subcategory.id">
        <product-category :product-category="subcategory"/>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {trans} from "../../../app";
import ProductCategoryService from "../../../services/ProductCategoryService";
import RulesBuilder from "../../../utils/rulesBuilder";

export default {
  data: function () {
    return {
      dialog: false,
      valid: false,
      loading: false,
      availableCategories: [],
      selectedCategory: null,
      rulesBuilder: null,
    };
  },
  created() {
    this.rulesBuilder = new RulesBuilder();
  },
  props: {
    productCategory: Object,
  },
  computed: {
    ...mapGetters(['productCategories']),
    rules: function () {
      return {
        category: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.product_category.title'))
              .getRules(),
        ],
      };
    },
  },
  methods: {
    ...mapActions(['setProductCategoryToEdit', 'setEditMode', 'deleteProductCategory', 'fetchProductCategories', 'setParentId']),
    createChild() {
      this.setParentId(this.productCategory.id);
    },
    edit() {
      this.setProductCategoryToEdit({
        id: this.productCategory.id,
        name: this.productCategory.name,
      });
      this.setEditMode(true);
    },
    async remove() {
      const productCategoryService = new ProductCategoryService();

      if (this.productCategory.subcategories.length > 0) {
        this.open();

        return;
      }

      const {data} = await productCategoryService.productCategoryHasRelatedProducts(this.productCategory.id);

      if (data.data.has_related_products === true) {
        this.open();

        return;
      }

      this.$confirmDanger(
          trans('app.product_category.confirm_category_removal', {category: this.productCategory.name}),
          trans('app.product_category.remove_category')
      ).then(async () => {
        await this.deleteProductCategory(this.productCategory.id);
        this.$toast.success(trans('app.actions.removed', {name: trans('app.product_category.category')}))
        await this.fetchProductCategories();
      }).catch((error) => {
        this.sentryCaptureException(error);
      })
    },
    closeModal() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    open() {
      this.dialog = true;
      this.availableCategories = [];
      this.loadAvailableCategories(this.productCategories);
    },
    loadAvailableCategories(productCategories, level = 0) {
      const prefix = new Array(level).fill('-').join(' ');
      productCategories.forEach(productCategory => {
        if (productCategory.id !== this.productCategory.id) {
          this.availableCategories.push({
            id: productCategory.id,
            name: `${prefix} ${productCategory.name}`,
          });
          this.loadAvailableCategories(productCategory.subcategories, level + 1);
        }
      });
    },
    async rewriteSubcategoriesAndProductCategoriesAndRemove() {
      const productCategoryService = new ProductCategoryService();
      await productCategoryService.deleteAndRewrite(this.productCategory.id, {new_product_id: this.selectedCategory});
      this.fetchProductCategories();
      this.closeModal();
    },
  },
}
</script>

<style scoped>

</style>
